import { Grid, styled, Typography } from '@mui/material'

export const Container = styled(Grid)(({ theme }) => ({
  width: '70%',
  minHeight: '100%',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    width: '90%',
  },
}))

export const List = styled('ol')(({ theme }) => ({
  fontSize: theme.typography.h6.fontSize,
  fontWeight: 'bold',
}))

export const ListItemText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h6.fontSize,
  margin: theme.spacing(1, 0, 3),
})) as typeof Typography
